import React from "react";
const BackArrowIcon: React.FC = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="14" fill="white" stroke="#04A9F4" />
      <path
        d="M9.921 16.3177L15.713 22.1711L15 22.8866L8 15.8124L15 8.73828L15.713 9.45378L9.921 15.3071H22V16.3177H9.921Z"
        fill="black"
      />
    </svg>
  );
};

export default BackArrowIcon;
